// src/pages/PageMenu/SettingsMenu.jsx
// قائمة الإعدادات — بالتصميم الموحّد (MenuKit) مع دعم الترجمة

import React from "react";
import { MenuPage } from "../../components/Menu/MenuKit";

import SettingsIcon from "@mui/icons-material/Settings";
import PointOfSaleIcon from "@mui/icons-material/PointOfSale";
import VerifiedUserOutlinedIcon from "@mui/icons-material/VerifiedUserOutlined";
import AccountTreeOutlinedIcon from "@mui/icons-material/AccountTreeOutlined";
import PercentIcon from "@mui/icons-material/Percent";
import PaymentsIcon from "@mui/icons-material/Payments";
import ReceiptIcon from "@mui/icons-material/Receipt";
import PrintIcon from "@mui/icons-material/Print";
import TuneIcon from "@mui/icons-material/Tune";
import BuildOutlinedIcon from "@mui/icons-material/BuildOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import LocalOfferOutlinedIcon from "@mui/icons-material/LocalOfferOutlined";
import DevicesOutlinedIcon from "@mui/icons-material/DevicesOutlined";

export default function SettingsMenu() {
  const sections = [
    {
      key: "system",
      titleKey: "settingsMenu.systemSection", titleFallback: "إعدادات النظام",
      subtitleKey: "settingsMenu.systemSectionDesc", subtitleFallback: "الإعدادات العامة ونقطة البيع والفوترة الإلكترونية والحسابات",
      icon: <TuneIcon />, color: "#4F46E5",
      items: [
        { key: "general", nameKey: "settingsMenu.generalSettings", nameFallback: "الإعدادات العامة", icon: <SettingsIcon />, color: "#4F46E5", link: "/settings" },
        { key: "pos", nameKey: "settingsMenu.posSettings", nameFallback: "إعدادات نقطة البيع", icon: <PointOfSaleIcon />, color: "#7C3AED", link: "/pos-settings" },
        { key: "posDevices", nameKey: "settingsMenu.posDevices", nameFallback: "أجهزة نقطة البيع", icon: <DevicesOutlinedIcon />, color: "#0D9488", link: "/pos/devices" },
        { key: "zatca", nameKey: "settingsMenu.zatcaSettings", nameFallback: "إعدادات الفاتورة الإلكترونية", icon: <VerifiedUserOutlinedIcon />, color: "#059669", link: "/zatca-settings" },
        { key: "gl", nameKey: "settingsMenu.glSettings", nameFallback: "توجيه الحسابات", icon: <AccountTreeOutlinedIcon />, color: "#2563EB", link: "/gl-settings" },
      ],
    },
    {
      key: "advanced",
      titleKey: "settingsMenu.advancedSection", titleFallback: "خيارات متقدمة",
      subtitleKey: "settingsMenu.advancedSectionDesc", subtitleFallback: "الضرائب وطرق الدفع وأنواع الفواتير وتصميم الطباعة",
      icon: <BuildOutlinedIcon />, color: "#D97706",
      items: [
        { key: "vat", nameKey: "settingsMenu.vatTypes", nameFallback: "أنواع الضرائب", icon: <PercentIcon />, color: "#D97706", link: "/vat-types" },
        { key: "pm", nameKey: "settingsMenu.paymentMethods", nameFallback: "طرق الدفع", icon: <PaymentsIcon />, color: "#DB2777", link: "/payment-methods" },
        { key: "types", nameKey: "settingsMenu.invoiceTypes", nameFallback: "أنواع الفواتير", icon: <ReceiptIcon />, color: "#0891B2", link: "/invoice-types" },
        { key: "print", nameKey: "settingsMenu.printLayout", nameFallback: "تصميم الفواتير", icon: <PrintIcon />, color: "#475569", link: "/print-layout" },
        { key: "promotions", nameKey: "settingsMenu.promotions", nameFallback: "العروض الترويجية", icon: <LocalOfferOutlinedIcon />, color: "#E11D48", link: "/promotions" },
      ],
    },
  ];

  return (
    <MenuPage
      titleKey="settingsMenu.title" titleFallback="الإعدادات"
      subtitleKey="settingsMenu.subtitle" subtitleFallback="إعدادات النظام والضرائب والطباعة"
      icon={<SettingsOutlinedIcon />}
      sections={sections}
    />
  );
}